export function getLang( { onlyUsingLanguageArr, defaultLang, }: { onlyUsingLanguageArr?: string[]; defaultLang: string } = { defaultLang: 'en', } ): string {
  let lang = $('html').attr('lang') || defaultLang;

  // html의 lang 속성이 허용된 언어안에 있는지 확인
  if ( onlyUsingLanguageArr && onlyUsingLanguageArr.length > 0 && !onlyUsingLanguageArr.includes(lang) ) {
    lang = defaultLang;
  }

  return lang;
}

export function getCountry( { onlyUsingCountry, defaultCountry, }: { onlyUsingCountry?: string[]; defaultCountry: string } = { defaultCountry: 'KR', } ): string {
  let country = $('html').attr('data-country') || defaultCountry;

  // html의 data-country 속성이 허용된 국가안에 있는지 확인
  if ( onlyUsingCountry && onlyUsingCountry.length > 0 && !onlyUsingCountry.includes(country) ) {
    country = defaultCountry;
  }

  return country;
}

export function getPlayncDomain(): string {
  let env = getSeviceEnv();
  let url = '';
  switch (env) {
    case 'opdev':
      url = 'https://opdev-www.plaync.com';
      break;
    case 'sandbox':
      url = 'https://opdev-www.plaync.com';
      break;
    case 'rc':
      url = 'https://rc-www.plaync.com';
      break;
    default:
      url = 'https://www.plaync.com';
      break;
  }
  return url;
}

export function getWstaticUrlObjectStorage(): string {
  let env = getSeviceEnv();
  let url = '';
  switch (env) {
    case 'opdev':
      url = 'https://op-assets.ncsoft.com';
      break;
    case 'sandbox':
      url = 'https://sb-assets.plaync.com';
      break;
    case 'rc':
      url = 'https://rc-assets.plaync.com';
      break;
    default:
      url = 'https://assets.playnccdn.com';
      break;
  }
  return url;
}


export function getWstaticUrl(): string {
  let env = getSeviceEnv();
  let url = '';
  switch (env) {
    case 'opdev':
      url = 'https://op-wstatic.ncsoft.com';
      break;
    case 'sandbox':
      url = 'https://sb-static.plaync.com';
      break;
    case 'rc':
      url = 'https://rc-wstatic.plaync.co.kr';
      break;
    default:
      url = 'https://wstatic-cdn.plaync.com';
      break;
  }
  return url;
}

export const getSeviceEnv = (): string => {
  if (/^(rc-tw.)/.test(location.hostname)) {
    return 'rc-tw';
  } else if (/^(tw.)/.test(location.hostname)) {
    return 'tw';
  } else if (/^(rc\.|rc-)/.test(location.hostname)) {
    return 'rc';
  } else if (/^opdev/.test(location.hostname)) {
    return 'opdev';
  } else if (/^op-/.test(location.hostname)) {
    return 'opdev';
  } else if (/^op./.test(location.hostname)) {
    return 'opdev';
  } else if (/^sb-/.test(location.hostname)) {
    return 'sandbox';
  } else if (/^local/.test(location.hostname)) {
    return 'opdev';
  } else {
    return 'live';
  }
};

export function getContiApiLocale(lang: string): string {
  let result = '';
  switch (lang) {
    case 'ar':
      result = 'ar-AE';
      break;
    case 'en':
      result = 'en-US';
      break;
    case 'id':
      result = 'id-ID';
      break;
    case 'ja':
      result = 'ja-JP';
      break;
    case 'ko':
      result = 'ko-KR';
      break;
    case 'th':
      result = 'th-TH';
      break;
    case 'zh':
      result = 'zh-TW';
      break;
    case 'ru':
      result = 'ru-RU';
      break;
    default:
      result = 'en-US';
      break;
  }
  return result;
}

export function getContiDomain(): string {
  let env = getSeviceEnv();
  let domain = '';
  switch (env) {
    case 'opdev':
      domain = 'https://rc-www.plaync.com';
      break;
    case 'sandbox':
      domain = 'https://rc-www.plaync.com';
      break;
    case 'rc':
      domain = 'https://rc-www.plaync.com';
      break;
    default:
      domain = 'https://www.plaync.com';
      break;
  }
  return domain;
}

